



































































import { defineComponent, onMounted } from "@vue/composition-api";
import SvgGeometry from "../SvgGeometry.vue";
import Block from "../Block.vue";
import Icon from "../Icon.vue";
import { useUtils, useCheckout } from "@front/store";
import { useUser } from "@front/store/user";
import { updateRouteLocation } from "@front/router";
import { scrollToElement } from "@iudo/shared/utils";
import { temporaryHighlightUserBuilding } from "@front/store/map/layers/buildings";
import { getBuildingsState, mapFitToUserLandUnit, setBuildingsState } from "@front/store/map";



export default defineComponent({

  components: {
    Block,
    Icon,
    SvgGeometry
  },
  setup() {
    onMounted(() => {
      // if (getRouteStep.value === ScrollIds.POTENTIAL) {
      // scrollToElement(`#${ScrollIds.POTENTIAL}`, {
      //   block: "start",
      // });
      // }
    });

    const activeMapBuilding = (id: any) => {
      if (getBuildingsState() === false) {
        setBuildingsState(true)
      }
      temporaryHighlightUserBuilding(id);
      mapFitToUserLandUnit()
      scrollToElement('#the-map', {block: "start"});
    }

    return {
      ...useUser(),
      ...useUtils(),
      ...useCheckout(),
      updateRouteLocation,
      activeMapBuilding
    };
  },
});
